import { Component, ViewChild } from '@angular/core';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { COLOR_PRIMARY_CONTRAST_500, LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { StoresDataComponent } from '../stores-data/stores-data.component';
import { StoresSummaryComponent } from '../stores-summary/stores-summary.component';
import { ListStoresParams } from 'src/app/core/stores.service';
import { DialogService } from 'src/app/core/dialog.service';
import { StoresFilterDialogComponent } from '../stores-filter-dialog/stores-filter-dialog.component';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.scss'],
})
export class StoresComponent {
  @ViewChild(StoresSummaryComponent)
  summary_component?: StoresSummaryComponent;
  @ViewChild(StoresDataComponent) data_component?: StoresDataComponent;
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(NavigationItemLabel.stores);
  filters?: ListStoresParams;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private dialog_service: DialogService,
    private meta: Meta,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
  }

  ngOnInit(): void {
    this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
  }

  onRefresh(): void {
    this.onFilterClear({});
    this.summary_component?.onRefresh();
    //this.data_component?.onRefresh();
  }

  onFilter(): void {
    this.dialog_service
      .openDialog(StoresFilterDialogComponent)
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.params) {
          this.filters = dialog_result.params;
          this.setDataFilters();
        }
      });
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  onFilterClear(filters: ListStoresParams): void {
    this.filters = filters;
    this.setDataFilters();
  }

  setDataFilters(): void {
    if (this.areFiltersSet()) {
      this.data_component?.onFilter(this.filters);
    }

    if (!this.areFiltersSet()) {
      this.data_component?.onFilter();
    }
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }

  areFiltersSet(): boolean {
    if (!this.filters) return false;

    const active_filters = Object.keys(this.filters).filter(k => {
      if (!this.filters) return false;
      return this.filters[k as keyof typeof this.filters] != null;
    });

    return active_filters && active_filters.length ? true : false;
  }
}
